import { render, staticRenderFns } from "./TableForm10.vue?vue&type=template&id=16d1f9da&scoped=true"
import script from "./TableForm10.vue?vue&type=script&lang=ts"
export * from "./TableForm10.vue?vue&type=script&lang=ts"
import style0 from "./TableForm10.vue?vue&type=style&index=0&id=16d1f9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1f9da",
  null
  
)

export default component.exports